import { AppValueTypes } from '@iotv/iotv-v3-types';
import { WrapLinkVOB } from '../../../factories/DataGrid';
import { dateTimeNow } from '../../../NetworkSystem/cellFormatters/valueFormatters';
export const spreadJSON = (value, row, column, apiRef) => {
    if (value) {
        return Object.values(value).map((val) => val.toString().padStart(3, '0')).join('  ');
    }
    return '';
};
export const GatewayAnalysisListViewDefintion = {
    name: {
        key: 'name',
        type: AppValueTypes.STRING,
        label: 'Name',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    eui: {
        key: 'eui',
        type: AppValueTypes.STRING,
        label: 'EUI',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    property: {
        key: 'property',
        type: AppValueTypes.STRING,
        label: 'Property',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    networkKey: {
        key: 'networkKey',
        type: AppValueTypes.STRING,
        label: 'NW ID',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    isAWOL: {
        key: 'isAWOL',
        type: AppValueTypes.BOOLEAN,
        label: 'Is AWOL',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    lastSeen: {
        key: 'lastSeen',
        type: AppValueTypes.DATE,
        label: 'Last Seen',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    dailyUpCount: {
        key: 'dailyUpCount',
        type: AppValueTypes.NUMBER,
        label: 'Daily Up Count',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    dailyDownCount: {
        key: 'dailyDownCount',
        type: AppValueTypes.NUMBER,
        label: 'Daily Down Count',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    deviceCount: {
        key: 'deviceCount',
        type: AppValueTypes.NUMBER,
        label: 'Device Count',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    fCntJump: {
        key: 'fCntJump',
        type: AppValueTypes.NUMBER,
        label: 'Frame Count Jump',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    acceptance: {
        key: 'acceptance',
        type: AppValueTypes.NUMBER,
        label: 'Acceptance Rate',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    sfArray: {
        key: 'sfArray',
        type: AppValueTypes.STRING,
        label: 'SF (7/8/9/10/11/12)',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
};
export const GatewayAnalysisColumnMap = {
    name: {
        headerName: 'Name',
        width: 200,
    },
    eui: {
        headerName: 'EUI',
        width: 180,
        renderCell: (p) => WrapLinkVOB(p, 'pk', undefined),
    },
    //   property: {
    //     headerName: 'Property',
    //     width: 200,
    //   },
    networkKey: {
        headerName: 'Network Key',
        width: 150,
    },
    isAWOL: {
        headerName: 'Is AWOL',
        width: 100,
    },
    lastSeen: {
        headerName: 'Last Active',
        valueFormatter: dateTimeNow,
        width: 200,
    },
    uplinks: {
        headerName: 'Up Count',
        width: 130,
    },
    // downlinks: {
    //   headerName: 'Down Count',
    //   width: 130,
    // },
    devices: {
        headerName: 'Device Count',
        width: 140,
    },
    droppedMsgs: {
        headerName: 'fCnt Jump',
        width: 130,
    },
    expectedCount: {
        headerName: 'Expected Uplinks',
        width: 160,
    },
    acceptance: {
        headerName: 'Rate (%)',
        width: 120,
    },
    expectedCount15: {
        headerName: 'Calculated Uplinks (15m/message)',
        width: 220,
    },
    acceptance15: {
        headerName: 'Rate (%) for 15',
        width: 160,
    },
    // sfArray: {
    //   headerName: 'SF(%) (7/8/9/10/11/12)',
    //   valueFormatter: spreadJSON,
    //   width: 250,
    // },
    snrMean: {
        headerName: 'Avg SNR',
        width: 100,
    },
};
